export default __webpack_public_path__ + "5_click_mobile_pl.png";